import type { Article, Category } from "../support.types";

/**
 * Finds the previous and next articles within the same category.
 * Recursively searches through subcategories.
 */
export function findSiblingSupportArticlesInCategory(
  cats: Category[],
  articleId: string
): { prev?: Article; next?: Article } {
  for (const cat of cats) {
    const articleIndex = cat.articles.findIndex((a) => a.id === articleId);
    if (articleIndex !== -1) {
      return {
        prev: articleIndex > 0 ? cat.articles[articleIndex - 1] : undefined,
        next:
          articleIndex < cat.articles.length - 1
            ? cat.articles[articleIndex + 1]
            : undefined,
      };
    }
    if (cat.subcategories.length > 0) {
      const siblings = findSiblingSupportArticlesInCategory(
        cat.subcategories,
        articleId
      );
      if (siblings.prev || siblings.next) return siblings;
    }
  }
  return { prev: undefined, next: undefined };
}

export default findSiblingSupportArticlesInCategory;
